import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { Route, useLocation, Link } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { useDispatch, useSelector } from "react-redux";

import { AppTopbar } from "./AppTopbar";
import { AppFooter } from "./AppFooter";
import { AppMenu } from "./AppMenu";
import { AppConfig } from "./AppConfig";
// import Login from "./pages/login/Login";

import PrimeReact from "primereact/api";
import { Tooltip } from "primereact/tooltip";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";

import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "./assets/demo/flags/flags.css";
import "./assets/demo/Demos.scss";
import "./assets/layout/layout.scss";
import "./App.scss";

// import Dashboard from "./components/Dashboard";
import Login from "./pages/auth/Login";
import { useHistory } from "react-router-dom";
import Signup from "./pages/signup/Signup";
import Customers from "./pages/customers/Customers";
import Customer from "./pages/customers/Customer";
import Staff from "./pages/staff/Staff";
import StaffMember from "./pages/staff/StaffMember";
import MyAccount from "./pages/account/MyAccount";
import AirportHandovers from "./pages/airportHandover/AirportHandovers";
import AirportHandoverDetail from "./pages/airportHandover/AirportHandoverDetail";
import InStorePickups from "./pages/inStorePickup/InStorePickups";
import InStorePickupDetail from "./pages/inStorePickup/InStorePickupDetail";
import Packages from "./pages/packages/Packages";
import Package from "./pages/packages/Package";
import Labels from "./pages/labels/Labels";
import Label from "./pages/labels/Label";
// import Deliveries from "./pages/Delivery/Deliveries";
// import GenerateReport from "./pages/Delivery/GenerateReport";
// import DeliveryReport from "./pages/Delivery/DeliveryReport";
import BillingReports from "./pages/billing/BillingReports";
import GenerateInvoice from "./pages/billing/GenerateInvoice";
import Invoice from "./pages/billing/Invoice";
// import BarcodeScannerComponent from "react-qr-barcode-scanner";
import Scan from "./pages/scan/Scan";
// import firebase from "./firebase/firebase";
import Verify from "./components/Verify";
import ResetEmail from "./components/ResetEmail";
import ResetPassword from "./components/ResetPassword";
import MassLabel from "./pages/labels/MassLabel";
import Payment from "./pages/payment/Payment";
import PendingPackage from "./pages/pending packages/PendingPackage";
import "react-tippy/dist/tippy.css";
import Logs from "./pages/logs/Logs";
import Partner from "./pages/partners/Partner";
import BillingReport from "./pages/Invoice/BillingReports";
import Inv from "./pages/Invoice/Invoice";
import BulkInvoices from "./pages/billing/BulkInvoices";
import Dashboard from "./components/Dashboard";
import DeliveryInfos from "./pages/DeliveryInfo/DeliveryInfos";
import DeliveryInfo from "./pages/DeliveryInfo/DeliveryInfo";
import Statuses from "./pages/PackageStatus/Statuses";
import Status from "./pages/PackageStatus/Status";
import Advance from "./pages/Advance/Advance";
import InvoiceAdvance from "./pages/InvoiceAdvance/InvoiceAdvance";
import Report from "./pages/billing/Report";
import BulkInv from "./pages/Invoice/BulkInvoice";
import PaymentBulk from "./pages/payment/PaymentBulk";
import useUrlChange from "./components/useUrlChange";
import Outstanding from "./modals/Outstanding";
import { Dialog } from "primereact/dialog";
import { MdFlight } from "react-icons/md";
import Flights from "./pages/flight/Flights";
import Flight from "./pages/flight/Flight";
// import Vehicles from "./pages/delivery/vehicles/Vehicles";
// import Milages from "./pages/delivery/milage/Milages";
// import HandlerMilages from "./pages/delivery/handler/HandlerMilages";
import FinancialReport from "./pages/FinancialReport/FinancialReport";
import PackageUpdate from "./pages/packageUpdate/PackageUpdate";
import Main from "./pages/packages/pendingPackages/Main";
import OCRPackages from "./pages/packages/ocrPackages/Main";
import PrviacyPolicy from "./pages/termsAndCondition/PrviacyPolicy";
import TrackShipment from "./pages/tracking/TrackShipment";
import { AppTopbar2 } from "./AppTopbar2";
import TermsAndCondition from "./pages/termsAndCondition/TermsAndCondition";
import Deliveries from "./pages/delivery/Deliveries";
import DeliveryTracking from "./pages/delivery/deliveryTracking/DeliveryTracking";
import DeliveryDetails from "./pages/delivery/DeliveryDetails";
import LiveTracking from "./pages/delivery/LiveTracking/LiveTracking";
import MassJamaicanLabel from "./pages/jamaicanLabels/MassJamaicanLabel";
import JamaicanLabels from "./pages/jamaicanLabels/JamaicanLabels";
import JamaicanLabel from "./pages/jamaicanLabels/JamaicanLabel";
import ClockInOut from "./pages/shifts/ClockInOut";
import ShiftHistory from "./pages/shifts/ShiftHistory";
import AdminShifts from "./pages/shifts/AdminShifts";
import AdminShiftDetail from "./pages/shifts/AdminShiftDetail";
import CashRegister from "./pages/cashRegister/CashRegister";
import AdminCashLedger from "./pages/cashRegister/AdminCashLedger";
import AdminCashSummary from "./pages/cashRegister/AdminCashSummary";
import AdminCashRegisters from "./pages/cashRegister/AdminCashRegisters";
import AdminExchangeRate from "./pages/cashRegister/AdminExchangeRate";
import AdminCashRegisterDetail from "./pages/cashRegister/AdminCashRegisterDetail";
import CashOut from "./pages/cashRegister/CashOut";
import RecordPayment from "./pages/clientPayment/RecordPayment";
import AdminPaymentHistory from "./pages/clientPayment/AdminPaymentHistory";
import { SET_SHIFT_STATUS } from "./redux/slices/activeShiftSlice";
import { fetchShiftStatus, GATED_SHIFT_ROLES } from "./services/shiftService";
import { startShiftGeoTracking, stopShiftGeoTracking } from "./services/shiftGeoTracker";

const App = () => {
    const naviagte = useHistory();
    const dispatch = useDispatch();
    const { checked: shiftChecked, onShift, shift: activeShift } = useSelector((s) => s.activeShiftSlice);
    const [layoutMode, setLayoutMode] = useState("static");
    const [layoutColorMode, setLayoutColorMode] = useState("light");
    const [inputStyle, setInputStyle] = useState("outlined");
    const [ripple, setRipple] = useState(true);
    const [staticMenuInactive, setStaticMenuInactive] = useState(false);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
    const [role, setRole] = useState("");
    const copyTooltipRef = useRef();
    const location = useLocation();
    const [email, setEmail] = useState("");
    require("dotenv").config();
    PrimeReact.ripple = true;
    let key = localStorage.getItem("token");
    let menuClick = false;
    let mobileTopbarMenuClick = false;

    useEffect(() => {
        if (mobileMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
    }, [mobileMenuActive]);

    useEffect(() => {
        if (mobileTopbarMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
    }, [mobileTopbarMenuActive]);

    useEffect(() => {
        let token = localStorage.getItem("token");
        if (!token) {
            if (window.location.pathname === "/verify") {
                // Keep the query string - the emailed link's ?token= is the
                // whole point of landing here (a bare push dropped it).
                naviagte.push("/verify" + window.location.search);
            } else if (window.location.pathname === "/reset") {
                naviagte.push("/reset" + window.location.search);
            } else if (window.location.pathname === "/resetPassword") {
                naviagte.push("/resetPassword" + window.location.search);
            } else {
                naviagte.push("/login");
            }
        }
    }, []);

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    };

    const onRipple = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onLayoutModeChange = (mode) => {
        setLayoutMode(mode);
    };

    const onColorModeChange = (mode) => {
        setLayoutColorMode(mode);
    };

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }

        if (!mobileTopbarMenuClick) {
            setMobileTopbarMenuActive(false);
        }

        mobileTopbarMenuClick = false;
        menuClick = false;
    };

    const onToggleMenuClick = (event) => {
        menuClick = true;

        if (isDesktop()) {
            if (layoutMode === "overlay") {
                if (mobileMenuActive === true) {
                    setOverlayMenuActive(true);
                }

                setOverlayMenuActive((prevState) => !prevState);
                setMobileMenuActive(false);
            } else if (layoutMode === "static") {
                setStaticMenuInactive((prevState) => !prevState);
            }
        } else {
            setMobileMenuActive((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const onSidebarClick = () => {
        menuClick = true;
    };

    const handleSignout = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("role");
        naviagte.push("/login");
    };

    const onMobileTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        setMobileTopbarMenuActive((prevState) => !prevState);
        event.preventDefault();
    };

    const onMobileSubTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        event.preventDefault();
    };

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
            setMobileTopbarMenuActive(false);
        }
    };
    const isDesktop = () => {
        return window.innerWidth >= 992;
    };
    const menu = [
        {
            items: [
                { label: "Dashboard", icon: "pi pi-chart-pie", to: "/" },
                { label: "Customers", icon: "pi pi-user", to: "/customers" },
                {
                    label: "Staff",
                    icon: "pi pi-id-card",
                    items: [
                        { label: "Manage Staff", icon: "pi pi-circle-fill", to: "/staff" },
                        { label: "Shift Reports", icon: "pi pi-circle-fill", to: "/admin/shifts" },
                    ],
                },
                {
                    label: "Packages",
                    icon: "pi pi-box",
                    items: [
                        { label: "All Packages", icon: "pi pi-circle-fill", to: "/packages" },
                        { label: "OCR Packages", icon: "pi pi-circle-fill", to: "/packages/ocr" },
                        { label: "Pending Packages", icon: "pi pi-circle-fill", to: "/packages/pending" },
                    ],
                },
                { label: "Track Packages", icon: "pi pi-map-marker", to: "/track" },
                { label: "Scan", icon: "pi pi-camera", to: "/scan" },
                {
                    label: "Labels",
                    icon: "pi pi-tags",
                    items: [
                        { label: "Standard Labels", icon: "pi pi-circle-fill", to: "/labels" },
                        { label: "Jamaican Labels", icon: "pi pi-circle-fill", to: "/jamaicanLabels" },
                    ],
                },
                {
                    label: "Logistics",
                    icon: "pi pi-car",
                    items: [
                        { label: "Flights", icon: "pi pi-circle-fill", to: "/flights" },
                        { label: "Deliveries", icon: "pi pi-circle-fill", to: "/deliveries" },
                        { label: "Airport Handovers", icon: "pi pi-circle-fill", to: "/airport-handovers" },
                        { label: "In-Store Pickups", icon: "pi pi-circle-fill", to: "/in-store-pickups" },
                    ],
                },
                {
                    label: "Finances",
                    icon: "pi pi-wallet",
                    items: [
                        { label: "Invoices", icon: "pi pi-circle-fill", to: "/invoices" },
                        { label: "Record Payment", icon: "pi pi-circle-fill", to: "/client-payment" },
                        { label: "Payment History", icon: "pi pi-circle-fill", to: "/admin/client-payments" },
                    ],
                },
                {
                    label: "Cash",
                    icon: "pi pi-money-bill",
                    items: [
                        { label: "Registers", icon: "pi pi-circle-fill", to: "/admin/cash-registers" },
                        { label: "Cash Ledger", icon: "pi pi-circle-fill", to: "/admin/cash-ledger" },
                        { label: "Cash Summary", icon: "pi pi-circle-fill", to: "/admin/cash-summary" },
                        { label: "Cash Out", icon: "pi pi-circle-fill", to: "/cash-out" },
                        { label: "Exchange Rate", icon: "pi pi-circle-fill", to: "/admin/exchange-rate" },
                    ],
                },
                { label: "Advance Features", icon: "pi pi-key", to: "/advance" },
            ],
        },
    ];

    const addClass = (element, className) => {
        if (element.classList) element.classList.add(className);
        else element.className += " " + className;
    };

    const removeClass = (element, className) => {
        if (element.classList) element.classList.remove(className);
        else element.className = element.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };

    const wrapperClass = classNames("layout-wrapper", {
        "layout-overlay": layoutMode === "overlay",
        "layout-static": layoutMode === "static",
        "layout-static-sidebar-inactive": staticMenuInactive && layoutMode === "static",
        "layout-overlay-sidebar-active": overlayMenuActive && layoutMode === "overlay",
        "layout-mobile-sidebar-active": mobileMenuActive,
        "p-input-filled": inputStyle === "filled",
        "p-ripple-disabled": ripple === false,
        "layout-theme-light": layoutColorMode === "light",
    });

    useEffect(() => {
        const role = localStorage.getItem("role");
        const emial = localStorage.getItem("email");
        setRole(role);
        setEmail(emial);
    }, []);

    // Shifts: fetch status on load and periodically, so onShift/viewOnly stay
    // current for the write-action gates and the view-only banner below.
    useEffect(() => {
        if (!key || !GATED_SHIFT_ROLES.includes(role)) return undefined;

        const refresh = async () => {
            const res = await fetchShiftStatus();
            if (res?.success) dispatch(SET_SHIFT_STATUS(res.data));
        };
        refresh();
        const poll = setInterval(refresh, 5 * 60 * 1000);
        return () => clearInterval(poll);
    }, [key, role, dispatch]);

    // Off-shift staff can browse the whole app read-only - every write route
    // is already gated server-side (utils/middlewares/requireShift.js), so
    // there's nothing unsafe about letting the UI render; this just stops
    // force-navigating them away from wherever they were looking.
    const viewOnly = !!key && GATED_SHIFT_ROLES.includes(role) && shiftChecked && !onShift;

    useEffect(() => {
        if (onShift) {
            startShiftGeoTracking(dispatch);
        } else {
            stopShiftGeoTracking();
        }
        return () => stopShiftGeoTracking();
    }, [onShift, dispatch]);

    const courierMenu = [
        {
            items: [
                {
                    label: "Packages",
                    icon: "pi pi-box",
                    items: [
                        { label: "All Packages", icon: "pi pi-circle-fill", to: "/" },
                        { label: "Pending Packages", icon: "pi pi-circle-fill", to: "/packages/pending" },
                    ],
                },
                { label: "Track Packages", icon: "pi pi-map-marker", to: "/track" },
                { label: "Invoices", icon: "pi pi-wallet", to: "/Userinvoices" },
            ],
        },
    ];

    const userMenu = [
        {
            items: [
                {
                    label: "Packages",
                    icon: "pi pi-box",
                    items: [
                        { label: "All Packages", icon: "pi pi-circle-fill", to: "/" },
                        { label: "Pending Packages", icon: "pi pi-circle-fill", to: "/packages/pending" },
                    ],
                },
                { label: "Track Packages", icon: "pi pi-map-marker", to: "/track" },
                { label: "Invoices", icon: "pi pi-wallet", to: "/Userinvoices" },
                { label: "My Account", icon: "pi pi-id-card", to: "/my-account" },
            ],
        },
    ];

    const clerkMenu = [
        {
            items: [
                { label: "Customers", icon: "pi pi-user", to: "/customers" },
                {
                    label: "Packages",
                    icon: "pi pi-box",
                    items: [
                        { label: "All Packages", icon: "pi pi-circle-fill", to: "/packages" },
                        { label: "Pending Packages", icon: "pi pi-circle-fill", to: "/packages/pending" },
                    ],
                },
                { label: "Track Packages", icon: "pi pi-map-marker", to: "/track" },
                {
                    label: "Labels",
                    icon: "pi pi-tags",
                    items: [
                        { label: "Standard Labels", icon: "pi pi-circle-fill", to: "/labels" },
                        { label: "Jamaican Labels", icon: "pi pi-circle-fill", to: "/jamaicanLabels" },
                    ],
                },
                {
                    label: "Logistics",
                    icon: "pi pi-car",
                    items: [
                        { label: "Flights", icon: "pi pi-circle-fill", to: "/flights" },
                        { label: "Deliveries", icon: "pi pi-circle-fill", to: "/deliveries" },
                        { label: "In-Store Pickups", icon: "pi pi-circle-fill", to: "/in-store-pickups" },
                    ],
                },
                {
                    label: "Finances",
                    icon: "pi pi-wallet",
                    items: [
                        { label: "Invoices", icon: "pi pi-circle-fill", to: "/invoices" },
                        { label: "Record Payment", icon: "pi pi-circle-fill", to: "/client-payment" },
                        { label: "Cash Out", icon: "pi pi-circle-fill", to: "/cash-out" },
                        onShift && activeShift?.workLocation === "in_store" ? { label: "Cash Register", icon: "pi pi-circle-fill", to: "/cash-register" } : null,
                    ].filter(Boolean),
                },
                {
                    label: "Shifts",
                    icon: "pi pi-clock",
                    items: [
                        { label: "Clock In/Out", icon: "pi pi-circle-fill", to: "/shifts" },
                        { label: "Shift History", icon: "pi pi-circle-fill", to: "/shifts/history" },
                    ],
                },
            ],
        },
    ];

    const airportMenu = [
        {
            items: [
                { label: "Scan", icon: "pi pi-camera", to: "/scan" },
                { label: "Airport Handovers", icon: "pi pi-send", to: "/airport-handovers" },
                {
                    label: "Shifts",
                    icon: "pi pi-clock",
                    items: [
                        { label: "Clock In/Out", icon: "pi pi-circle-fill", to: "/shifts" },
                        { label: "Shift History", icon: "pi pi-circle-fill", to: "/shifts/history" },
                    ],
                },
            ],
        },
    ];

    const handlerMenu = [
        {
            items: [
                { label: "Packages", icon: "pi pi-box", to: "/packages" },
                { label: "Track Packages", icon: "pi pi-map-marker", to: "/track" },
                {
                    label: "Labels",
                    icon: "pi pi-tags",
                    items: [
                        { label: "Standard Labels", icon: "pi pi-circle-fill", to: "/labels" },
                        { label: "Jamaican Labels", icon: "pi pi-circle-fill", to: "/jamaicanLabels" },
                    ],
                },
                {
                    label: "Logistics",
                    icon: "pi pi-car",
                    items: [
                        { label: "Flights", icon: "pi pi-circle-fill", to: "/flights" },
                        { label: "Deliveries", icon: "pi pi-circle-fill", to: "/deliveries" },
                        { label: "Airport Handovers", icon: "pi pi-circle-fill", to: "/airport-handovers" },
                        { label: "In-Store Pickups", icon: "pi pi-circle-fill", to: "/in-store-pickups" },
                    ],
                },
                {
                    label: "Shifts",
                    icon: "pi pi-clock",
                    items: [
                        { label: "Clock In/Out", icon: "pi pi-circle-fill", to: "/shifts" },
                        { label: "Shift History", icon: "pi pi-circle-fill", to: "/shifts/history" },
                    ],
                },
                {
                    label: "Cash",
                    icon: "pi pi-money-bill",
                    items: [{ label: "Cash Out", icon: "pi pi-circle-fill", to: "/cash-out" }],
                },
            ],
        },
    ];

    const driverMenu = [
        {
            items: [
                { label: "Deliveries", icon: "pi pi-box", to: "/deliveries" },
                { label: "Flights", icon: "pi pi-send", to: "/flights" },
                { label: "Packages", icon: "pi pi-box", to: "/packages" },
                { label: "Track Packages", icon: "pi pi-map-marker", to: "/track" },
                {
                    label: "Shifts",
                    icon: "pi pi-clock",
                    items: [
                        { label: "Clock In/Out", icon: "pi pi-circle-fill", to: "/shifts" },
                        { label: "Shift History", icon: "pi pi-circle-fill", to: "/shifts/history" },
                    ],
                },
            ],
        },
    ];

    const getMenu = () => {
        if (role === "admin") {
            return menu;
        } else if (role === "admin") {
            return menu;
        } else if (role === "courier") {
            return courierMenu;
        } else if (role === "client") {
            return userMenu;
        } else if (role === "clerk") {
            return clerkMenu;
        } else if (role === "airportStaff") {
            return airportMenu;
        } else if (role === "reseller") {
            return userMenu;
        } else if (role === "corporate") {
            return userMenu;
        } else if (role === "handler") {
            return handlerMenu;
        } else if (role === "driver") {
            return driverMenu;
        }
    };

    const getMainRoute = () => {
        if (role === "admin") {
            return <Route exact path="/" component={Dashboard} />;
        } else if (role === "courier") {
            return <Route exact path="/" component={Packages} />;
        } else if (role === "client") {
            return <Route exact path="/" component={Packages} />;
        } else if (role === "clerk") {
            return <Route exact path="/" component={Packages} />;
        } else if (role === "reseller") {
            return <Route exact path="/" component={Packages} />;
        } else if (role === "corporate") {
            return <Route exact path="/" component={Packages} />;
        } else if (role === "handler") {
            return <Route exact path="/" component={Packages} />;
        } else if (role === "driver") {
            return <Route exact path="/" component={Deliveries} />;
        }
    };
    const [data, setData] = useState();

    const [collasped, setCollasped] = useState(false);
    console.log(collasped);

    const [showSoftStop, setShowSoftStop] = useState(false);

    const onHideSoftStop = () => {
        setShowSoftStop(false);
    };

    const onSuccessSoftStop = () => {
        setShowSoftStop(false);
    };

    return (
        <div className={wrapperClass} onClick={onWrapperClick}>
            <ToastContainer />
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />
            <>
                {window.location.pathname === "/login" ? (
                    <Route exact path="/login" component={Login} />
                ) : window.location.pathname === "/signup" ? (
                    <Route exact path="/signup" component={Signup} />
                ) : window.location.pathname === "/verify" ? (
                    <Route exact path="/verify" component={Verify} />
                ) : window.location.pathname === "/reset" ? (
                    <Route exact path="/reset" component={ResetEmail} />
                ) : window.location.pathname === "/resetPassword" ? (
                    <Route exact path="/resetPassword" component={ResetPassword} />
                ) : window.location.pathname === "/privacy-policy" ? (
                    <>
                        <AppTopbar2 onToggleMenuClick={onToggleMenuClick} layoutColorMode={layoutColorMode} mobileTopbarMenuActive={mobileTopbarMenuActive} onMobileTopbarMenuClick={onMobileTopbarMenuClick} onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick} />
                        <Route exact path="/privacy-policy" component={PrviacyPolicy} />
                    </>
                ) : window.location.pathname === "/termsAndCondition" ? (
                    <>
                        <AppTopbar2 onToggleMenuClick={onToggleMenuClick} layoutColorMode={layoutColorMode} mobileTopbarMenuActive={mobileTopbarMenuActive} onMobileTopbarMenuClick={onMobileTopbarMenuClick} onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick} />
                        <Route exact path="/termsAndCondition" component={TermsAndCondition} />
                    </>
                ) : (
                    <>
                        <AppTopbar
                            onToggleMenuClick={onToggleMenuClick}
                            layoutColorMode={layoutColorMode}
                            mobileTopbarMenuActive={mobileTopbarMenuActive}
                            onMobileTopbarMenuClick={onMobileTopbarMenuClick}
                            onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick}
                            menu={getMenu()}
                            onMenuItemClick={onMenuItemClick}
                            onSignout={handleSignout}
                        />
                        <div className="layout-sidebar" onClick={onSidebarClick} style={{ width: `${collasped ? "80px" : "300px"}` }}>
                            <div className="sidebar-collapse-row">
                                <button type="button" className="sidebar-collapse-btn" onClick={() => setCollasped((prev) => !prev)} aria-label={collasped ? "Expand menu" : "Collapse menu"}>
                                    <i className={collasped ? "pi pi-angle-right" : "pi pi-angle-left"} />
                                </button>
                            </div>
                            <AppMenu model={getMenu()} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} collasped={collasped} />
                            <div className="sidebar-footer">
                                <button type="button" className="sidebar-logout-btn" onClick={handleSignout}>
                                    <i className="pi pi-sign-out" />
                                    {!collasped && <span>Logout</span>}
                                </button>
                            </div>
                        </div>
                        <div className={`${collasped ? "laymain2" : "layout-main-container"}`}>
                            <div className="layout-main">
                                {viewOnly && location.pathname !== "/shifts" && (
                                    <div className="view-only-banner">
                                        <i className="pi pi-eye" />
                                        <span>
                                            You're not clocked in - browsing in view-only mode. <Link to="/shifts">Clock in</Link> to take actions.
                                        </span>
                                    </div>
                                )}
                                {getMainRoute()}
                                {<Route exact path="/customers" component={Customers} />}
                                {<Route exact path="/customer/:id" component={Customer} />}
                                {role === "admin" && <Route exact path="/staff" component={Staff} />}
                                {role === "admin" && <Route exact path="/staff/:id" component={StaffMember} />}
                                {<Route exact path="/packages" component={Packages} />}
                                {<Route exact path="/package/:id" component={Package} />}
                                {<Route exact path="/track" component={TrackShipment} />}
                                {<Route exact path="/track/:code" component={TrackShipment} />}
                                {<Route exact path="/labels" component={Labels} />}
                                {<Route exact path="/jamaicanLabels" component={JamaicanLabels} />}
                                {<Route exact path="/jamaicanLabel/:id" component={JamaicanLabel} />}
                                {<Route exact path="/label/:id" component={Label} />}
                                {<Route exact path="/invoices" component={InvoiceAdvance} />}
                                {<Route exact path="/generateInvoice" component={GenerateInvoice} />}
                                {<Route exact path="/invoice" component={Invoice} />}
                                {<Route exact path="/scan" component={Scan} />}
                                {<Route exact path="/BulkLabels" component={MassLabel} />}
                                {<Route exact path="/BulkJamaicanLabels" component={MassJamaicanLabel} />}
                                {<Route exact path="/PendingPackages" component={PendingPackage} />}
                                {<Route exact path="/logs" component={Logs} />}
                                {<Route exact path="/payment" component={Payment} />}
                                {<Route exact path="/partners" component={Partner} />}
                                {<Route exact path="/Userinvoices" component={BillingReport} />}
                                {<Route exact path="/userInvoice" component={Inv} />}
                                {<Route exact path="/bulkInvoices" component={BulkInvoices} />}
                                {<Route exact path="/DeliveryInfos" component={DeliveryInfos} />}
                                {<Route exact path="/statuses" component={Statuses} />}
                                {<Route exact path="/DeliveryInfo/:id" component={DeliveryInfo} />}
                                {<Route exact path="/status/:id" component={Status} />}
                                {<Route exact path="/advance" component={Advance} />}
                                {<Route exact path="/invoice/:status" component={BillingReports} />}
                                {<Route exact path="/report/:status" component={Report} />}
                                {<Route exact path="/bulkInvoicesUser" component={BulkInv} />}
                                {<Route exact path="/bulkPayment" component={PaymentBulk} />}
                                {<Route exact path="/flights" component={Flights} />}
                                {<Route exact path="/flight" component={Flight} />}
                                {/* {<Route exact path="/vehicles" component={Vehicles} />}
                                {<Route exact path="/milageReports" component={Milages} />} */}
                                {/* {<Route exact path="/handlerDeliveryReport" component={HandlerMilages} />} */}
                                {<Route exact path="/financialReport" component={FinancialReport} />}
                                {<Route exact path="/updatePackage" component={PackageUpdate} />}
                                {<Route exact path="/packages/pending" component={Main} />}
                                {<Route exact path="/packages/ocr" component={OCRPackages} />}
                                {<Route exact path="/my-account" component={MyAccount} />}
                                {<Route exact path="/airport-handovers" component={AirportHandovers} />}
                                {<Route exact path="/airport-handover/:id" component={AirportHandoverDetail} />}
                                {<Route exact path="/in-store-pickups" component={InStorePickups} />}
                                {<Route exact path="/in-store-pickup/:id" component={InStorePickupDetail} />}
                                {<Route exact path="/deliveries" component={Deliveries} />}
                                {<Route exact path="/shifts" component={ClockInOut} />}
                                {<Route exact path="/shifts/history" component={ShiftHistory} />}
                                {role === "admin" && <Route exact path="/admin/shifts" component={AdminShifts} />}
                                {role === "admin" && <Route exact path="/admin/shifts/:id" component={AdminShiftDetail} />}
                                {role === "clerk" && <Route exact path="/cash-register" component={CashRegister} />}
                                {role === "admin" && <Route exact path="/admin/cash-ledger" component={AdminCashLedger} />}
                                {role === "admin" && <Route exact path="/admin/cash-summary" component={AdminCashSummary} />}
                                {role === "admin" && <Route exact path="/admin/cash-registers" component={AdminCashRegisters} />}
                                {role === "admin" && <Route exact path="/admin/cash-registers/:id" component={AdminCashRegisterDetail} />}
                                {role === "admin" && <Route exact path="/admin/exchange-rate" component={AdminExchangeRate} />}
                                {(role === "admin" || role === "handler" || role === "clerk") && <Route exact path="/cash-out" component={CashOut} />}
                                {(role === "admin" || role === "clerk") && <Route exact path="/client-payment" component={RecordPayment} />}
                                {role === "admin" && <Route exact path="/admin/client-payments" component={AdminPaymentHistory} />}
                                {role !== "clerk" && <Route exact path="/delivery/:id/tracking" component={DeliveryTracking} />}
                                {<Route exact path="/delivery/:id/details" component={DeliveryDetails} />}
                                {role !== "clerk" && <Route exact path="/delivery/:id/live-tracking" component={LiveTracking} />}

                                {/* {<Route exact path="/deliveryReport/admin/generate" component={GenerateReport} />}
                                {<Route exact path="/delivery/:id" component={DeliveryReport} />} */}
                            </div>
                            {/* <AppFooter layoutColorMode={layoutColorMode} /> */}
                        </div>
                    </>
                )}
            </>

            <AppConfig rippleEffect={ripple} onRippleEffect={onRipple} inputStyle={inputStyle} onInputStyleChange={onInputStyleChange} layoutMode={layoutMode} onLayoutModeChange={onLayoutModeChange} layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange} />

            <CSSTransition classNames="layout-mask" timeout={{ enter: 200, exit: 200 }} in={mobileMenuActive} unmountOnExit>
                <div className="layout-mask p-component-overlay"></div>
            </CSSTransition>
        </div>
    );
};

export default App;
